<template>
  <div id="container" v-loading.fullscreen="loading">
    <div class="detail_main" v-if="list">
      <div class="searchResults">
        <div class="resultsBox full_layout">
          <span class="resultsSpan">{{ $t('vault.CardHobbyVault') }}</span>
          <span class="resultsSpan"> > {{ $t('vault.InVault') }} > {{ $t('vault.Consigned') }} </span>
        </div>
      </div>
      <div class="cardDetailsBox full_layout">
        <div class="cardDetails Release">
          <card-swiper :list="imgList" />
        </div>
        <div class="details">
          <h1>
            {{ list.Title }}
            <template v-if="list.EffectiveTime && list.Status == 4">
              <div>
                <span :class="{ 'text_red': (list.itemEndClass == 1) }">{{ $t('colon.timeLeft') }}
                  <em>{{ list.itemEnd }}</em></span>
                <span>{{ setTime(list.EffectiveTime) }}</span>
              </div>
            </template>
            <div class="text_blue">{{ $t('vault.VaultID') }}：{{ list.Code }}</div>
          </h1>
          <div class="price_btn_box line">
            <template v-if="list.Status == 4">
              <div class="vault_td">
                <div class="current-price">
                  <span>
                    {{ list.ByWay === 2 ? $t('colon.CurrentBid') : $t('colon.price') }}
                  </span>
                  <span class="price" style="font-size: 24px;font-weight: bold;">
                    USD {{ ThousandAndDecimal(list.USD_Price || list.Price) }}
                  </span>
                </div>

              </div>
              <div>
                <span class="icon_auction" v-if="list.ByWay === 1 && list.Bargain == 1">
                  <!-- @*一口价 议价 报价次数*@ -->
                  {{ list.AuctionCount }} {{ $t('base.Offers') }}
                </span>
                <span class="icon_auction" v-if="list.ByWay === 2">
                  <!-- @*竞价数*@ -->
                  {{ list.AuctionCount }} {{ $t('base.bids') }}
                </span>
              </div>
            </template>
          </div>
          <div class="price_btn_box">
            <div class="vr-price">
              <div class="current-price">
                <span>{{ list.Status == 1 ? $t('vault.EstimatedValue') + ':' : $t('colon.price') }}</span>
                <span class="text_lg">USD {{ ThousandAndDecimal(list.UsdPrice || list.EstimatePrice) }}</span>
              </div>
              <span class="text_gray small_text">{{ $t('vault.EstimatedVaultValue') }}</span>
            </div>
          </div>
          <template v-if="codeScore&&codeScore.Score">
            <div class="codeScore">  
              <div>
                <span class="text_blue">{{codeScore.Company}}</span>
                <span>{{codeScore.Score}}</span>
              </div>
              <div>
                <span class="text_red">POP</span>
                <span>{{codeScore.TotalPopulation}}</span>
              </div>
              <div>
                <span class="text_yellow">POP HIGHER</span>
                <span>{{codeScore.TotalAbovePopulation}}</span>
              </div>
            </div>
          </template>
          <template v-if="list.Defect">
              <div class="defect-info text_red"><span>{{ $t('vault.Defect') }}：</span><span class="defect-desc">{{ list.DefectDsc}}</span></div>
            </template>
          <template v-if="list.Status == 5">
            <div class="vr-sold-tip">
              <p class="sold-text">{{ $t('vault.Sold') }}</p>
              <p class="sold-sub">{{ $t('vault.accountberestricted') }}</p>
            </div>
          </template>
          <template v-if="list.Status==2">
            <el-button class="price_btn_box" type="primary"><router-link style="color:#fff" :to="{ path:`/mycardhobby/warehouse`, query:{vaultType:0} }">{{$t('vault.ForwardtoWarehouse')}}</router-link></el-button>
          </template>
          <template v-else>
            <el-button class="price_btn_box" type="primary"><router-link style="color:#fff" :to="{ path:`/vault/myvault/${list.ValutId}`, query:{vaultType:0} }">{{ $t('vault.ViewonCardHobbyVault') }}</router-link></el-button>
          </template>
        </div>
        <div class="sellerInfoBox" v-if="list.ApplyStatus != 0">
          <div class="seller_info">
            <div class="seller_info_title">{{ $t('base.sellerInfo') }}</div>
            <span class="sellerInfo_title">
              <span class="sellerInfo_a StoreName line_txt1">{{ list.ResalerName }}</span>
            </span>
            <span :class="['vr-tag', 'vs-status'+list.ApplyStatus]">{{ ApplyStatusEnum[list.ApplyStatus] }}</span>
            <div class="line line_tb"></div>
            <div class="sellerInfo_a sellerInfo_a_h" v-if="userInfo != null && list.Resaler != userInfo.MappingUserId"
              @click="allContact(list.Resaler)">{{ $t('base.contactSeller') }}</div>
          </div>
        </div>
        <!-- detail auction-->
        <!-- <buy-now :list='list' :postageList="postageList" v-if="list"/> -->
      </div>
    </div>
    <f-z-f :title="errorMsg" v-if="!loading && !list" />
  </div>
  <!-- 没商品显示默认报错界面 -->
</template>
<script>
import { countDown, getInfo, getTime, setUTC, priceExchange, GoYunXin, GetWorldUSD, getAreaDetail } from "@/api/public";
import FZF from "@/components/404.vue";
import CardSwiper from "@/components/swiper/card";
import commonEventJs from "@/common/CommonEventJs.js";


export default {
  name: "index",
  components: { CardSwiper, FZF },
  data() {
    return {
      loading: false,
      codeScore:'',
      list: [],
      imgList: [],
      userInfo: '',
      cid: '',//商品id
      nowData: setUTC(new Date().getTime(), -8),

    };
  },
  watch: {
    nowData: {
      immediate: true,
      handler(val) {
        const that = this
        try {
          let itemEnd = that.list.EffectiveTime.toString().replace(/-/g, "/")
          itemEnd = setUTC(itemEnd, -8, 'cn')
          that.list.itemEnd = countDown(itemEnd, val)
          that.list.itemEndClass = countDown(itemEnd, val, 0)
        } catch (e) {

          //console.log('itemEnd:', e, 'val:', val)
        }
      }
    },
  },
  created() {
    this.cid = this.$route.params.id
    this.userInfo = getInfo()
    this.getVaultDetails()
  },
  computed: {
    ApplyStatusEnum() {
      return {
        0: this.$t('vault.AwaitingConsignment'),
        1: this.$t('vault.ApplicationPending'),
        2: this.$t('vault.Accepted'),//委托中
      }
    },
    ThousandAndDecimal() {
      return function (num) {
        //金额千分位
        return commonEventJs.thousandAndDecimal(num);
      }
    },
  },
  beforeRouteUpdate(to, from, next) {

  },
  mounted() {
    this.cardTimer()
  },
  methods: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    cardTimer() {
      setTimeout(() => {
        var nowTime = new Date().getTime()
        this.nowData = setUTC(nowTime, -8)
        this.cardTimer()
      }, 1000)
    },
    getVaultDetails() {
      const that = this
      const data = { id: this.cid }
      that.$get(that.$interface.GetCommodityById, data).then(res => {
        if (res.Result > 0 && res.Data) {
          that.list = res.Data
          that.imgList = res.Data.images && res.Data.images.indexOf(',') !== -1 ? res.Data.images.split(',') : (res.Data.TitImg ? [res.Data.TitImg] : [])
          if (that.list.CardId) {
            that.getCardDetails()
          }

        }
      });
    },
    getCardDetails() {
      const that = this
      const data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': that.list.CardId }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result > 0) {
          that.list.Title = res.data.Title
          that.list.USD_Price = res.data.USD_Price
          that.list.EffectiveTime = res.data.EffectiveTime
          that.list.ByWay=res.data.ByWay
          that.list.AuctionCount=res.data.AuctionCount
        }
      });
    },
    allContact(val) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val, this.cid, 1000)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },

  },
};

</script>
<style scoped>
@import "../../../static/css/carddetails.css";

.cardDetailsBox {
  gap: 40px;
}

.details {
  flex: 1;
  width: auto;
}

.price_btn_box {
  margin-top: 16px;
}

.icon_auction {
  display: flex;

}

.icon_auction:before {
  content: "";
  background: url(../../../static/images/icon/icon_gray_auction.svg) no-repeat 0 1px;
  background-size: auto 80%;
  display: block;
  width: 18px;
  height: 18px;
}

.text_gray {
  margin: 0;
}

.vr-sold-tip {
  background-color: #efefef;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 12px;
  border-radius: 4px;
  margin-top: 16px;
}

.sold-text {
  color: #333;
  font-size: 16px;
  margin: 0 0 4px 0;
}

.sold-sub {
  color: #a0a0a0;
  font-size: 12px;
  margin: 0;
}
.defect-info{
  margin: 16px 0;
}
.vr-tag{
  border: 1px solid;
  padding: 2px 6px;
  border-radius: 4px;
}
.vs-status2,.vs-status1{
  background-color: rgba(5, 130, 63, 0.10);
  border-color:#C6E5D5;
  color: #05823F;
}
</style>



// WEBPACK FOOTER //
// src/pages/carddetails/vault.vue